import React from "react";
import "chart.js/auto";
import { Bar } from "react-chartjs-2";
import { useEnquiryAnalyticsQuery } from "state/api";
import Loader from "components/Loader";

const options = {
  responsive: true,
  plugins: {
    legend: {
      display: false,
    },
    title: {
      display: false,
      text: "Car Company Trends",
    },
    colors: {
      enabled: true,
    },
  },
  scales: {
    x: {
      grid: {
        display: false,
      },
      ticks: {
        color: "rgba(0, 0, 0, 0.54)",
      },
    },
    y: {
      grid: {
        display: false,
      },
      ticks: {
        color: "rgba(0, 0, 0, 0.54)",
      },
    },
  },
};

const CarCompanyTrends = () => {
  let { data: carCompanyStats, isLoading } = useEnquiryAnalyticsQuery();
  carCompanyStats = {
    ...carCompanyStats?.carCompanyTrends,
  };

  return (
    <>
      {isLoading ? (
        <Loader />
      ) : (
        <Bar
          data={{
            labels: carCompanyStats?.labels,

            datasets: [
              {
                label: "Number of Enquiries",
                data: carCompanyStats?.data,
                backgroundColor: "rgba(153, 102, 255, 0.8)",
              },
            ],
          }}
          options={options}
        />
      )}
    </>
  );
};

export default CarCompanyTrends;
